import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sb-account',
  templateUrl: './sb-account.component.html',
  styleUrls: ['./sb-account.component.css']
})
export class SbAccountComponent implements OnInit {
  title = "SB/CA Account Opening";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master-account/sb-account/sb-account.component.ts